(() => {
  const GIFT_PROPERTY_KEY = '_gift';
  const GIFT_PROPERTY_VALUE = 'true';
  const SOURCE_ID = 'cart-gift-promo';
  const CART_UPDATE = 'cart:update';

  const state = {
    processing: false,
    pending: false,
  };

  function getElement() {
    return document.querySelector('cart-gift-promo');
  }

  function getThreshold(el) {
    return parseInt(el.dataset.threshold || '2', 10);
  }

  function getVariantId(el) {
    return el.dataset.variantId;
  }

  function sectionsToUpdate() {
    const ids = new Set();
    document.querySelectorAll('cart-items-component[data-section-id]').forEach((node) => {
      if (node instanceof HTMLElement && node.dataset.sectionId) {
        ids.add(node.dataset.sectionId);
      }
    });
    return Array.from(ids).join(',');
  }

  function dispatchCartUpdate(sections) {
    document.dispatchEvent(
      new CustomEvent(CART_UPDATE, {
        bubbles: true,
        detail: {
          sourceId: SOURCE_ID,
          data: {
            source: SOURCE_ID,
            sections,
          },
        },
      })
    );
  }

  function updateBanner(qualifyingCount, threshold) {
    const banners = document.querySelectorAll('[data-gift-banner]');
    if (!banners.length) return;

    const remaining = Math.max(threshold - qualifyingCount, 0);
    const earned = remaining === 0;
    const empty = qualifyingCount === 0;

    banners.forEach((banner) => {
      banner.hidden = earned || empty;
      const progressEl = banner.querySelector('[data-gift-progress]');
      if (progressEl) {
        const template = progressEl.dataset.template || '';
        progressEl.textContent = template.replace('[count]', String(remaining));
      }
    });
  }

  async function postJSON(url, body) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });
    const data = await response.json().catch(() => null);
    return { ok: response.ok, status: response.status, data };
  }

  async function addGift(variantId) {
    const sections = sectionsToUpdate();
    const result = await postJSON('/cart/add.js', {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: { [GIFT_PROPERTY_KEY]: GIFT_PROPERTY_VALUE },
        },
      ],
      sections,
      sections_url: window.location.pathname,
    });
    if (!result.ok) {
      console.warn('[cart-gift-promo] no se pudo añadir el regalo', result.status, result.data);
      return;
    }
    dispatchCartUpdate(result.data?.sections);
  }

  async function changeGift(key, quantity) {
    const sections = sectionsToUpdate();
    const result = await postJSON('/cart/change.js', {
      id: key,
      quantity,
      sections,
      sections_url: window.location.pathname,
    });
    if (!result.ok) {
      console.warn('[cart-gift-promo] no se pudo actualizar el regalo', result.status, result.data);
      return;
    }
    dispatchCartUpdate(result.data?.sections);
  }

  async function evaluate() {
    const el = getElement();
    if (!el) {
      return;
    }

    const variantId = getVariantId(el);
    if (!variantId) {
      console.warn('[cart-gift-promo] no variantId set on element');
      return;
    }
    const threshold = getThreshold(el);

    if (state.processing) {
      state.pending = true;
      return;
    }

    state.processing = true;
    try {
      const cart = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      }).then((r) => r.json());

      const giftLine = cart.items.find(
        (item) =>
          String(item.variant_id) === String(variantId) &&
          item.properties &&
          item.properties[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VALUE
      );

      const qualifyingCount = cart.items.reduce((acc, item) => {
        if (item.properties && item.properties[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VALUE) {
          return acc;
        }
        return acc + item.quantity;
      }, 0);

      console.debug('[cart-gift-promo] evaluate', {
        variantId,
        threshold,
        qualifyingCount,
        giftLineFound: !!giftLine,
        items: cart.items.map((i) => ({ id: i.variant_id, qty: i.quantity, gift: i.properties && i.properties._gift })),
      });

      updateBanner(qualifyingCount, threshold);

      if (qualifyingCount >= threshold && !giftLine) {
        console.debug('[cart-gift-promo] adding gift');
        await addGift(variantId);
      } else if (qualifyingCount < threshold && giftLine) {
        console.debug('[cart-gift-promo] removing gift');
        await changeGift(giftLine.key, 0);
      } else if (giftLine && giftLine.quantity !== 1) {
        console.debug('[cart-gift-promo] forcing gift qty to 1');
        await changeGift(giftLine.key, 1);
      }
    } catch (e) {
      console.error('[cart-gift-promo]', e);
    } finally {
      state.processing = false;
      if (state.pending) {
        state.pending = false;
        evaluate();
      }
    }
  }

  document.addEventListener(CART_UPDATE, (event) => {
    const source = event && event.detail && event.detail.data && event.detail.data.source;
    if (source === SOURCE_ID) return;
    setTimeout(() => evaluate(), 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => evaluate(), { once: true });
  } else {
    setTimeout(() => evaluate(), 0);
  }

  if (!customElements.get('cart-gift-promo')) {
    customElements.define(
      'cart-gift-promo',
      class extends HTMLElement {
        connectedCallback() {
          setTimeout(() => evaluate(), 0);
        }
      }
    );
  }

  console.debug('[cart-gift-promo] module loaded');
})();
